import { IMediaModel, useIsPlayableWithDate } from "@nf/common";
import { CountryCode } from "@nf/constants";
import React from "react";
import { useTranslation } from "react-i18next";

import Badge from "components/Badge/Badge";
import { useCountry } from "../../hooks";

import styles from "./AvailabilityLabel.module.scss";

const config = {
  [CountryCode.Danish]: {
    dateFormat: "DD. MMM",
  },
  [CountryCode.Finnish]: {
    dateFormat: "D.M",
  },
};

interface AvailabilityLabelProps {
  media: IMediaModel;
}

export const AvailabilityLabel = ({ media }: AvailabilityLabelProps) => {
  const { t } = useTranslation("translations");
  const country = useCountry();
  const { isComingSoon, isExpiring, availableFrom, availableTo } =
    useIsPlayableWithDate(media, config[country.toUpperCase() as CountryCode]);

  if (isExpiring) {
    return (
      <Badge variant="secondary" size="medium" className={styles.label}>
        {t("web_asset_expire")} {availableTo}
      </Badge>
    );
  }

  if (isComingSoon) {
    return (
      <Badge variant="primary" size="medium" className={styles.label}>
        {availableFrom}
      </Badge>
    );
  }

  return null;
};

export default AvailabilityLabel;
